




















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({})
export default class BindableDatePicker extends Vue {
  @Prop({ default: moment() }) public value!: moment.Moment;

  private internalDate: string = "";
  private showDateMenu: boolean = false;

  @Watch("value")
  protected updateInternalDate() {
    this.internalDate = this.value.toISOString();
  }

  @Watch("internalDate")
  protected updateValue() {
    if (this.value.toISOString() !== this.internalDate) {
      this.$emit("input", moment(this.internalDate));
    }
  }

  protected get dateString() {
    return this.value.format("DD/MM/YY");
  }
}
